import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { withRouter } from 'react-router-dom';

class OfferCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      name: '',
      nameErrorText: '',
      errorMessage: ''
    };

    this.state = {
      ...this.initialState
    };
  }
  handleNameChange = (event, name) => {
    this.setState({nameErrorText: '', name});
  }
  handleCancel = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }
  validateName = () => {
    const {t} = this.props;
    if(!this.state.name) {
      this.setState({nameErrorText: t('required')});
      return false;
    }
    return true;
  }
  handleSave = () => {
    const {firebase, user} = this.props;
    if (!this.validateName()) return;

    const offer = {
      name: this.state.name
    };

    firebase.database().ref(`shopkeepers/${user.shopkeeperId}/offers/`).push(offer).then((data) => {
      this.props.history.push(`/offers/${data.key}`);
    });
    this.handleCancel();
  }
  render() {
    const {t} = this.props;

    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleCancel}
      />,
      <RaisedButton
        label={t('submit')}
        type="submit"
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    return (
      <Dialog
        title={t('offer.create')}
        open={this.props.open}
        onRequestClose={this.handleCancel}
        actions={actions}
      >
        <TextField hintText={t('offer.name')}
          floatingLabelText={t('offer.name')}
          errorText={this.state.nameErrorText}
          onChange={this.handleNameChange}
          onBlur={this.validateName}
          value={this.state.name}
        />
      </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user, withRouter);

export default enhance(OfferCreate);



// WEBPACK FOOTER //
// ./src/Offer/OfferCreate.js